import type { SalesChecklistItem } from "@expert/contentful";
import type { JSX } from "react";

import { Flex, Image, Text } from "@mantine/core";

import type { OfferChecklistState } from "../../../../../stores/useOfferChecklistStore";

import { useSalesContext } from "../../../../../sales-context/SalesContext";
import { useOfferChecklistStore } from "../../../../../stores/useOfferChecklistStore";
import { UncheckedRadioIcon } from "../../Icons";
import { GreenCheckMark } from "../../Icons/GreenCheckMark";
import { BillingDetailsToolTip } from "./BillingDetailsToolTip";

export function ChecklistItem({
    item: { phrase, subheading, highlightColor, key, popupDescriptionText, popupLinkText, icon },
}: {
    item: SalesChecklistItem;
}): JSX.Element | null {
    const { sessionId } = useSalesContext();
    const data = useOfferChecklistStore((state) => state.getData(sessionId));

    const isDetected = key in data ? data[key as keyof OfferChecklistState["data"]] : false;

    return (
        <Flex key={phrase} direction="column">
            <Text mb="3xs" c="dark.1" size="xs">
                {subheading}
            </Text>
            <Flex p={highlightColor ? "10px 10px 10px 4px" : undefined} bg={isDetected ? undefined : highlightColor}>
                {isDetected ? <GreenCheckMark /> : <UncheckedRadioIcon />}
                <Text w="100%" ml="3xs" mr="3xs" c={isDetected ? "dark.3" : "dark.1"} size="xs">
                    {phrase}
                </Text>
                {icon && !isDetected && <Image w="auto" style={{ alignSelf: "flex-start" }} fit="contain" src={icon} />}
            </Flex>
            {popupLinkText && popupDescriptionText && (
                <BillingDetailsToolTip title={popupLinkText} body={popupDescriptionText} />
            )}
        </Flex>
    );
}
